module.exports = __webpack_public_path__ + "static/media/modern-design.930b558d.jpg";